import React from 'react';
import TopBar from '../../components/TopBar';
import ActionIconButton from '../../components/ActionIconButton';
import RequestsTopBarFilter from './RequestsTopBarFilter';
import { retrieveServiceRequestItems } from './RequestState';

const {
  ActionsLeft,
  ActionsRight,
} = TopBar;

const RequestsTopBar = function RequestsTopBar() {
  return (
    <TopBar>
      <ActionsLeft>
        <RequestsTopBarFilter />
      </ActionsLeft>
      <ActionsRight>
        <ActionIconButton action={retrieveServiceRequestItems} icon="refresh" />
      </ActionsRight>
    </TopBar>
  );
};

export default RequestsTopBar;



// WEBPACK FOOTER //
// ./src/views/requests/RequestsTopBar.js